module.exports = __webpack_public_path__ + "img/xian.508cf3e7.png";